const BSTypes = {
    BS_ACTION_START:"BS_ACTION_START",
    BS_FETCH_DATA:"BS_FETCH_DATA",
    BS_FETCH_DATA_FAILED:"BS_FETCH_DATA_FAILED",
    BS_ADD_DATA:"BS_ADD_DATA",
    BS_FETCH_DATA_CLEAR: "BS_FETCH_DATA_CLEAR"
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
    set_payload: ""
}

const BSReducer = (state=Initial_state, action) => {
    switch(action.type){
        case BSTypes.BS_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case BSTypes.BS_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload.data,
                set_payload: action.payload.set_payload
            }

        case BSTypes.BS_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }
        case BSTypes.BS_FETCH_DATA_CLEAR: 
            return {
                ...Initial_state,
            }

        default:
            return state;
    }
};

export default BSReducer;